<template>
  <div class="academic-container">
    <div class="banner-container">
      <div class="banner-content">
        <div class="banner-title">学术研究</div>
        <div class="banner-info">了解优图最新动态</div>
      </div>
    </div>
    <div class="academic-content">
      <div class="academic-bar" :class="{'is-fixed': secondNavFixed}">
        <div class="anchors-items">
          <div class="anchors-item" :class="{'active-anchors' : key == indexActive}" v-for="(item, key) in AnchorsItems"
            :key="key" @click="goAnchor(key)">
            {{item}}
          </div>
        </div>
      </div>
      <div v-if="indexActive === 'PAPER'" class="academic-paper">
        <div class="academic-bar-place">
          <div class="academic-select-box">
            <el-select  v-model="yearValue" clearable placeholder="年份" @change="yearChange">
              <el-option v-for="item in yearOptions" :key="item" :label="item" :value="item">
              </el-option>
            </el-select>
            <el-select  v-model="journalValue" clearable placeholder="会议/期刊" @change="journalChange">
              <el-option v-for="item in journalOptions" size="mini" :key="item" :label="item" :value="item">
              </el-option>
            </el-select>
          </div>
          <div class="academic-item-container">
            <div v-if="academic.length > 0" class="academic-item" v-for="item in currentAcademic" :key="item.title">
              <div class="logo-case-one" @click="handleJumpPage(item.article)">
                <div class="academic-journal">{{item.journal}}</div>
                <div class="academic-year">{{item.year}}</div>
              </div>
              <div class="info-content" @click="handleJumpPage(item.article)">{{item.title}}</div>
              <div class="info-other">
                <div class="info-other-year">{{item.conference}}</div>
                <div class="info-detail" @click="handleJumpPage(item.article)">
                  <div class="info-detail-link">了解详情</div><div class="info-detail-icon"></div>
                </div>
              </div>
            </div>
            <div class="academic-no-data" v-if="academic.length == 0">暂无数据</div>
          </div>
        </div>
        <div class="academic-pagination" v-if="academic.length > 0">
          <el-pagination :page-size="pageSize" :current-page="currentPage" layout="prev, pager, next" :total="academic.length"
            @current-change="academicPageChange"></el-pagination>
        </div>
      </div>
      <div v-else>
        <div class="community-content">
          <div class="left-menu-box">
            <div class="left-menu" :class="{'menu-is-fixed': secondNavFixed}">
              <div class="menu-item" :class="{'menu-active': indexMenuActive === 1}" @click="scrollToModule(1, 'openSource')">开源介绍</div>
              <div class="menu-item" :class="{'menu-active': indexMenuActive === 2}" @click="scrollToModule(2, 'technical')">技术研究类</div>
              <div class="menu-item" :class="{'menu-active': indexMenuActive === 3}" @click="scrollToModule(3, 'engineering')">工程框架类</div>
            </div>
          </div>
          <div class="right-content">
            <div>
              <div class="open-source">
                <div class="module-title" id="openSource">开源介绍</div>
                <div class="introduce">
                  <p>腾讯优图正式走向开源道路是在 2017 年，伴随腾讯内部开源策略的倡导，腾讯爆发式输出了 20 个自主开源的优秀项目，其中就包含腾讯优图的开源作品：神经网络推理框架 ncnn，此后，腾讯优图又陆续上线了算法类的一系列开源项目，如人脸检测算法 DSFD（Dual Shot Face Detector）、动作检测算法 DBG、通用目标检测算法 OSD（OneStageDet）、图像超分 SuperResolution-RealSR、人脸关键点算法 FHR(Fractional Heatmap Regression ) 、人脸属性算法 FAN 。20年 6 月，腾讯优图实验室又开源了神经网络推理框架 TNN。</p>
                  <p>从开源的项目类别来讲，腾讯优图的项目可以大致分为两类：工程框架类和算法研究类。工程框架类如深度学习框架 ncnn 和 TNN，算法研究类项目包含人脸检测、目标检测、动作检测、图像超分等领域在内的算法和各类工具等。其中，腾讯优图最“火”的三个开源项目是：NCNN、DSFD、TNN，分别在 GitHub 上收获了 10.4k、2.4k、2.2k 的 Star 数。</p>
                  <p>2018 年，自腾讯技术委员会、腾讯开源管理办公室成立后，在腾讯全公司推进开源协同策略，推动优质开源协同项目对外开源的同时，腾讯开源战略链条正在不断完善。今年年初，腾讯高级执行副总裁汤道生首次公开阐述开源对于腾讯的意义，“开源不再是开发者的个人热情，它已成为许多技术驱动型产业背后重要的创新推动力。腾讯将进一步拥抱开源，与广大开发者一起创造正向价值”，而腾讯优图身在其中，积极践行和拥抱开源策略。</p>
                </div>
              </div>
              <div class="technical-research">
                <div class="module-title" id="technical">技术研究类</div>
                <div class="common-box-container">
                  <div class="common-box">
                    <div class="common-box-title">SuperResolution-RealSR（2020）</div>
                    <div class="common-box-content">一种用于解决真实带噪模糊图像超分的新型 degradation（降质）框架-Real-SR，为超分辨率学习提供更接近真实图像的训练数据。</div>
                    <div class="common-box-detail" @click="handleJumpPage('https://github.com/Tencent/Real-SR')">了解详情</div>
                  </div>
                  <div class="common-box">
                    <div class="common-box-title">ActionDetection-DBG（2020）</div>
                    <div class="common-box-content">一种新的动作检测框架：DBG，性能优于最先进的动作检测算法BSN 和 BMN。</div>
                    <div class="common-box-detail" @click="handleJumpPage('https://github.com/Tencent/ActionDetection-DBG')">了解详情</div>
                  </div>
                  <div class="common-box">
                    <div class="common-box-title">FaceDetection-DSFD（2019）</div>
                    <div class="common-box-content">高精度双分支人脸检测器DSFD，在WIDER FACE 和 FDDB数据集均取得了精度第一 (刚出来时)。</div>
                    <div class="common-box-detail" @click="handleJumpPage('https://github.com/Tencent/FaceDetection-DSFD')">了解详情</div>
                  </div>
                  <div class="common-box">
                    <div class="common-box-title">FaceAttribute-FAN（2018）</div>
                    <div class="common-box-content">人脸属性识别是一个重要而又具有挑战性的研究课题。</div>
                    <div class="common-box-detail" @click="handleJumpPage('https://github.com/TencentYoutuResearch/FaceAttribute-FAN')">了解详情</div>
                  </div>
                  <div class="common-box">
                    <div class="common-box-title">FaceAlignment-FHR（2018）</div>
                    <div class="common-box-content">基于高分辨率视频的人脸对齐算法：Fractional Heatmap Regression (FHR)。</div>
                    <div class="common-box-detail" @click="handleJumpPage('https://github.com/TencentYoutuResearch/FaceAlignment-FHR')">了解详情</div>
                  </div>
                </div>
              </div>
              <div class="engineering-framework" id="engineering">
                <div class="module-title">工程框架类</div>
                <div class="common-box-container">
                  <div class="common-box">
                    <div class="common-box-title">InferenceFramework-TNN（2020）</div>
                    <div class="common-box-content">TNN是一个高性能、轻量级神经网络推理框架。主要解决深度学习不同训练框架在不同芯片部署性能瓶颈问题。</div>
                    <div class="common-box-detail" @click="handleJumpPage('https://github.com/Tencent/TNN')">了解详情</div>
                  </div>
                  <div class="common-box">
                    <div class="common-box-title">InferenceFramework-NCNN（2017）</div>
                    <div class="common-box-content">NCNN 是一个针对移动平台优化的高性能神经网络推理框架。</div>
                    <div class="common-box-detail" @click="handleJumpPage('https://github.com/Tencent/ncnn')">了解详情</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ScrollManager from '@/components/open/common/ScrollManager';
import RouteKey from '@/common/RouteKey';
import PublicationsConstant from './data/PublicationsConstant';

const academicData = PublicationsConstant.data.map(item => {
  const pattern = new RegExp('[0-9]+');
  let year = item.conference.match(pattern)[0];
  let numIndex = item.conference.indexOf(year);
  return {...item, 'journal': item.conference.slice(0, numIndex).trim(), year};
});
const SCROLL_TOP = 380;
const INDEX_MAP = [0, 884, 1668];
const SCROLL_AREA = [882, 1580];

export default {
  name: 'Academic',
  data() {
    return {
      AnchorsItems: {
        PAPER: '学术论文',
        COMMUNITY: '开源社区'
      },
      academic: academicData,
      currentAcademic: [],
      secondNavFixed: false,
      indexActive: 'PAPER',
      yearOptions: [],
      journalOptions: [],
      yearValue: '',
      journalValue: '',
      pageSize: 9,
      currentPage: 1,
      indexMenuActive: 1
    };
  },
  mounted() {
    ScrollManager.register(this.handleMouseScroll);
    this.academic = academicData;
    this.currentAcademic = this.academic.slice(0, this.pageSize);
    this.yearOptions = [...new Set(this.academic.map(item => item.year))];
    this.journalOptions = [...new Set(this.academic.map(item => item.journal))];
  },
  methods: {
    handleMouseScroll(param) {
      if (param == null) {
        return;
      }
      let scrollTop = param.scrollTop;
      if (scrollTop < SCROLL_TOP) {
        this.secondNavFixed = false;
        return;
      }
      this.secondNavFixed = true;
      if (scrollTop < SCROLL_AREA[0]) {
        this.indexMenuActive = 1;
      }
      this.indexMenuActive = scrollTop < SCROLL_AREA[0] ? 1 : (scrollTop < SCROLL_AREA[1] ? 2 : 3);
    },
    scrollToModule(index, key) {
      this.indexMenuActive = index;
      window.scrollTo(0, INDEX_MAP[index - 1]);
    },
    handleJumpPage(url, key) {
      if (url.indexOf('http') !== -1 || url.indexOf('files/pdffile') > -1) {
        window.open(url, '_blank');
        return;
      }
      url = RouteKey[url];
      if (key != null) {
        this.$router.transfer(url, {key: key});
        return;
      }
      this.$router.transfer(url);
    },
    goAnchor(key) {
      this.indexActive = key;
      if (key === 'PAPER') {
        this.currentPage = 1;
        this.academic = academicData;
        this.currentAcademic = this.academic.slice(0, this.pageSize);
      } else {
        this.academic = [];
        this.currentAcademic = [];
      }
      this.yearValue = null;
      this.journalValue = null;
      // document.documentElement.scrollTop = SCROLL_TOP;
    },
    yearChange(key) {
      if (key) {
        this.academic = academicData.filter(item => this.journalValue ? (item.journal === this.journalValue && item.year === key) : (item.year === key));
      } else {
        this.academic = academicData.filter(item => this.journalValue ? item.journal === this.journalValue : true);
      }
      this.currentAcademic = this.academic.slice(0, this.pageSize);
      this.currentPage = 1;
    },
    journalChange(key) {
      if (key) {
        this.academic = academicData.filter(item => this.yearValue ? (item.year === this.yearValue && item.journal === key) : (item.journal === key));
      } else {
        this.academic = academicData.filter(item => this.yearValue ? item.year === this.yearValue : true);
      }
      this.currentAcademic = this.academic.slice(0, this.pageSize);
      this.currentPage = 1;
    },
    academicPageChange(pageNum) {
      this.currentAcademic = this.academic.slice(pageNum > 1 ? ((pageNum - 1) * this.pageSize) : 0, pageNum * this.pageSize);
      this.currentPage = pageNum;
    }
  },
  beforeDestroy() {
    ScrollManager.degister(this.handleMouseScroll);
  }
};
</script>

<style lang="less" scoped>
.academic-container{
  background-color: #ffffff;
  div{
    box-sizing: border-box;
  }
  .banner-container{
    width: 100%;
    color: #ffffff;
    background-image: url(./img/banner_paper.jpg);
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    .banner-content{
      width: 1263px;
      height: 360px;
      padding-left: 30px;
      margin: 60px auto 0;
      .banner-title{
        font-size: 40px;
        font-family: 'PingFangSC-Medium';
        color: #000000;
        font-weight: 500;
        padding-top: 125px;
      }
      .banner-info{
        height: 32px;
        font-size: 18px;
        color: #3D485D;
        line-height: 32px;
        margin-top: 10px;
      }
    }
  }
  .academic-content {
    .academic-bar {
      width: 100%;
      min-width: 1200px;
      height: 60px;
      overflow: hidden;
      z-index: 2;
      background-color: #ffffff;
      border-bottom: 1px solid #eeeeee;
      .anchors-items {
        font-size: 0;
        text-align: center;
        .anchors-item {
          cursor: pointer;
          display: inline-block;
          margin: 0 45px;
          font-size: 17px;
          line-height: 50px;
          padding-top: 5px;
          &:hover {
            color: #0080FF;
            border-bottom: 4px solid #0080FF;
          }
          &.active-anchors{
            color: #0080FF;
            border-bottom: 4px solid #0080FF;
          }
        }
      }
      &.is-fixed{
        position: fixed;
        top: 63px;
        z-index: 1;
      }
    }
    .academic-paper {
      padding-bottom: 120px;
      .academic-bar-place {
        width: 1263px;
        margin: 55px auto 0;
        position: relative;
        background-color: #ffffff;
        min-height: 200px;
        .academic-select-box {
          position: absolute;
          right: 32px;
          top: -40px;
          /deep/ .el-select .el-input{
            width: 130px !important;
            .el-input__icon {
              line-height: 34px;
            }
          }
        }
        .academic-item-container {
          display: flex;
          justify-content: flex-start;
          flex-wrap: wrap;
          padding: 10px 20px 20px;
          .academic-item {
            /* height: 180px; */
            border: 1px solid rgba(232,236,241,1);
            width: 385px;
            height: 400px;
            padding: 20px;
            margin: 11px;
            position: relative;
            .logo-case-one{
              width: 340px;
              height: 190px;
              background: url('./img/img_bg_paper.png') center center no-repeat;
              opacity: 0.8;
              text-shadow: 0 1px 2px rgba(0,128,255,0.10);
              color: #3D485D;
              .academic-journal {
                font-family: 'PingFangSC-Semibold';
                font-size: 40px;
                text-align: center;
                line-height: 40px;
                font-weight: 600;
                padding-top: 57px;
              }
              .academic-year {
                height: 25px;
                line-height: 25px;
                font-size: 18px;
                text-align: center;
                margin-top: 10px;
              }
              &:hover {
                cursor: pointer;
              }
            }
            .info-content {
              font-size: 14px;
              width: 340px;
              font-family: 'PingFangSC-Semibold';
              font-size: 18px;
              color: #000000;
              line-height: 27px;
              font-weight: 600;
              margin-top: 20px;
              word-wrap : break-word;
              text-justify: left;
              user-select: none;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 3;
              -webkit-box-orient: vertical;
              &:hover {
                cursor: pointer;
                color: #0080FF;
              }
            }
            .info-other {
              width: 340px;
              position: absolute;
              left: 20px;
              bottom: 20px;
              font-size: 14px;
              color: #3D485D;
              box-sizing: border-box;
              .info-other-year {
                opacity: 0.8;
              }
              .info-detail {
                position: absolute;
                right: 0;
                top: 0;
                height: 20px;
                .info-detail-link {
                  opacity: 0.6;
                  display: inline-block;
                  vertical-align: top;
                }
                .info-detail-icon {
                  width: 20px;
                  height: 20px;
                  display: none;
                }
                &:hover {
                  cursor: pointer;
                  color: #0080FF;
                  .info-detail-link {
                    opacity: 1;
                  }
                  .info-detail-icon {
                    display: inline-block;
                    background: url("./img/arrow_normal.svg") center center no-repeat;
                  }
                }
              }
            }
            &:hover {
              box-shadow: 8px 8px 20px 0px rgba(0,47,73,0.1);
            }
          }
          .academic-no-data {
            color: black;
            opacity: 0.8;
            font-size: 16px;
            color: #3D485D;
            width: 100px;
            margin: 0 auto;
            text-align: center;
            padding-top: 80px;
          }
        }
      }
      .academic-pagination {
        padding-top: 20px;
        display: flex;
        justify-content: center;
        /deep/ .el-pagination {
          button {
            border: 1px solid #DDDDDD !important;
            padding: 6px !important;
            min-width: 40px;
            height: 40px;
          }
          .el-pager {
            .number {
              height: 40px;
              line-height: 40px;
              font-family: 'MicrosoftYaHei';
              font-size: 12px;
              color: #3D485D;
              opacity: 0.6;
              text-align: center;
              font-weight: 400;
              padding: 0 5px;
            }
            .active {
              color: #000000;
              opacity: 1;
            }
            .el-icon {
              height: 40px;
              line-height: 40px;
            }
            .more::before {
              line-height: 40px;
            }
          }
        }
      }
    }
    .community-content {
      width: 1263px;
      margin: 30px auto 0;
      padding: 20px 30px 120px;
      display: flex;
      .left-menu-box {
        width: 200px;
        min-height: 100%;
        .left-menu {
          width: 200px;
          .menu-item {
            height: 25px;
            color: #3D485D;
            font-size: 16px;
            line-height: 25px;
            padding-left: 15px;
            border-left: 5px solid transparent;
            margin: 10px 0;
            &:hover {
              cursor: pointer;
            }
            &.menu-active {
              color: #0080FF;
              font-family: 'PingFangSC-Semibold';
              font-weight: 600;
              border-color: #0080FF;
            }
          }
          &.menu-is-fixed {
            position: fixed;
            top: 123px;
          }
        }
      }
      .right-content {
        flex: 1;
        .module-title {
          height: 30px;
          line-height: 30px;
          font-family: 'PingFangSC-Semibold';
          font-size: 28px;
          color: #000000;
          font-weight: 500;
        }
        .open-source {
          font-size: 16px;
          color: #3D485D;
          text-align: justify;
          line-height: 28px;
          border-bottom: 1px solid rgba(232,236,241,1);
          padding: 8px 0 30px;
          .introduce {
            padding-top: 15px;
            > p {
              padding: 16px 0;
            }
          }
        }
        .technical-research, .engineering-framework {
          margin-top: 120px;
          padding-bottom: 60px;
          border-bottom: 1px solid rgba(232,236,241,1);
        }
        .common-box-container {
          display: flex;
          justify-content: flex-start;
          flex-wrap: wrap;
          margin-top: 30px;
          .common-box {
            width: 480px;
            height: 165px;
            background: #FFFFFF;
            padding: 20px;
            border: 1px solid rgba(232,236,241,1);
            margin: 10px;
            position: relative;
            .common-box-title {
              font-family: 'PingFangSC-Medium';
              font-size: 18px;
              color: #000000;
              font-weight: 500;
              margin-bottom: 10px;
            }
            .common-box-content {
              opacity: 0.8;
              font-size: 14px;
              color: #3D485D;
              text-align: justify;
              line-height: 25px;
            }
            .common-box-detail {
              width: 80px;
              height: 20px;
              font-size: 14px;
              color: #3D485D;
              opacity: 0.6;
              position: absolute;
              left: 20px;
              bottom: 20px;
              &:hover {
                cursor: pointer;
                color: #0080FF;
                opacity: 1;
                background-image: url(./img/arrow_normal.svg);
                background-position: center right;
                background-repeat: no-repeat;
              }
            }
          }
        }

      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/open/panels/academic/Academic.vue